import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Weather from './Weather';
import './App.css';
import"./Weather.css"

function App() {
  return (
    <div className="App">
      <div className="Container">
      <header className="App-header">
    
      <Weather />
      </header>
       <footer className='text-center'>
        This project was coded by Mandy Nkabane and is 
        <a href='https://github.com/nkabanemandih/project-react'> open-sourced on Github</a>
       </footer>
      
    </div>
    </div>
  );
}

export default App;
